import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Feature } from 'app/shared/services/app/application/feature.model';

@Component({
  selector: 'tog-feature-bubble',
  templateUrl: 'feature-bubble.template.html',
  styleUrls: ['feature-bubble.scss'],
})
export class FeatureBubbleComponent {
  @Input() feature: Feature;
  @Input() showName: boolean = true;
  @Input() selected: boolean = false;
  @Output() onToggle = new EventEmitter();

  onSelect() {
    this.feature.selected = !this.feature.selected;
    this.onToggle.emit(this.feature.system_name);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/feature-bubble/feature-bubble.component.ts